const slideshow = new Splide( '#slideshow', {
  type: 'fade',
  arrows: false,
  pagination: false,
  autoplay: true,
  interval: 2500,
  rewind: true,
  speed: 1000
});

slideshow.mount();

const carrouselConfig  = {
  drag: 'free',
  pagination: false,
  arrows: false,
  autoWidth: true,
  //snap: true,
  //perMove: 1
}

const carrouselsElements = document.querySelectorAll('[data-carrousel]');
const carrousels = [];

carrouselsElements.forEach(element => 
  carrousels.push(
    new Splide(
      `[data-carrousel="${element.dataset.carrousel}"]`,
      carrouselConfig
    )
  )
);

carrousels.forEach(carrousel => carrousel.mount());
